/**
 * Labstep
 *
 * @module components/ResourceItem/Action/CreateProtocolValue
 * @desc Create ResourceItem for ProtocolValue output
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { Can } from 'labstep-web/components/Entity/Can';
import { Action } from 'labstep-web/components/Entity/Can/types';
import ResourceItemActionCreate from 'labstep-web/components/ResourceItem/Action/Create';
import type { ActionComponentProps } from 'labstep-web/core/Action/Component/types';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import { Resource } from 'labstep-web/models/resource.model';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import type React from 'react';
import type {
  IResourceItemActionCreateProtocolValueProps,
  IResourceItemActionCreateProtocolValueWithProtocolConditionProps,
} from './types';

const defaultActionComponentProps: ActionComponentProps = {
  type: 'button',
  text: 'Create Item',
  elementProps: { basic: true },
};

export const ResourceItemActionCreateProtocolValue: React.FC<
  IResourceItemActionCreateProtocolValueProps
> = ({ protocolValue, ...rest }) => (
  <Can
    entityName={protocolValue.entityName}
    id={protocolValue.guid}
    action={Action.edit}
    field="resource_item"
  >
    {protocolValue.resource ? (
      <EntityActionCreate
        entityName={ResourceItem.entityName}
        body={{
          resource_id: protocolValue.resource.id,
          amount: protocolValue.amount,
          unit: protocolValue.unit,
          protocol_value_origin_guid: protocolValue.guid,
        }}
        actionComponentProps={defaultActionComponentProps}
        {...rest}
        overwriteCanCreateProps={{
          parentId: protocolValue.resource.id,
          parentName: Resource.entityName,
          entityName: ResourceItem.entityName,
        }}
      />
    ) : (
      <ResourceItemActionCreate
        withRedirect={false}
        actionComponentProps={defaultActionComponentProps}
        protocolValueOrigin={protocolValue}
        resourceTemplate={
          protocolValue.resource_template || undefined
        }
        {...rest}
      />
    )}
  </Can>
);

export const ResourceItemActionCreateProtocolValueWithProtocolCondition: React.FC<
  IResourceItemActionCreateProtocolValueWithProtocolConditionProps
> = ({ body, protocolValue, ...rest }) => {
  return (
    <ResourceItemActionCreate
      withRedirect={false}
      actionComponentProps={defaultActionComponentProps}
      protocolValueOriginBody={!protocolValue ? body : undefined}
      protocolValueOrigin={protocolValue || undefined}
      {...rest}
    />
  );
};
